import React from 'react'
import ProjectInfoView from './ProjectInfoView'
import EstimateView from './EstimateView'
import SpecView from './SpecView'
import ContractView from './ContractView'
import PaymentView from './PaymentView'
import DevView from './DevView'
import CompleteView from './CompleteView'
import ClientDevPaymentView from './ClientDevPaymentView'

function ProjectRightView(props) {
    var nums = props.nums
    var my = props.my

    if (nums === 0) {
        return <ProjectInfoView {...props} />
    }

    if (nums === 1) {
        return <EstimateView {...props} />
    }

    if (nums === 2) {
        if (my) return null
        return <SpecView {...props} />
    }

    if (nums === 3) {
        return <ContractView {...props} />
    }

    // 기존 납부 탭
    if (nums === 4) {
        return <PaymentView {...props} />
    }

    // client/my 개발 탭 안에 납부 붙이기
    if (nums === 5 || nums === 6 || nums === 7) {
        if (my) {
            return <ClientDevPaymentView {...props} />
        }

        return <DevView {...props} />
    }

    if (nums === 8) {
        return <CompleteView {...props} />
    }

    // admin 단계이동용 납부 가상 탭
    if (nums === 41) {
        return <PaymentView {...props} paymentLabel="선금 납부" />
    }

    if (nums === 42) {
        return <PaymentView {...props} paymentLabel="중도금 납부" />
    }

    if (nums === 43) {
        return <PaymentView {...props} paymentLabel="잔금 납부" />
    }

    return null
}

export default ProjectRightView
